import { getSentryInstance } from "./lib/sentry";
export { serializeErrorForSentry } from "./serialize-error-for-sentry";

export const captureErrorToSentry = (
	error: unknown,
	extraData: Record<string, unknown> = {},
	title?: string,
) => {
	const captureException = getSentryInstance().captureException;

	const err = error instanceof Error ? error : new Error(String(error));
	// biome-ignore lint/suspicious/noExplicitAny: sentry scope expects any
	captureException(err, (scope: any) => {
		scope.setExtras(extraData);
		if (title) {
			scope.setTransactionName(title);
		}
		return scope;
	});
};
